export interface Sample {
    documentType: DocumentType;
    extension: string;
    fileName: string;
    fileUrl: string;
    id: string;
    name: string;
    pages: number;
    previewUrl: string;
    region?: string;
    size: number;
    thumbnailUrl: string;
    token: string;
    type: string;
}

export interface SamplesByType {
  [index: string]: Sample[];
}

export enum DocumentType {
  Invoices = 'invoice',
  Contracts = 'contract',
  Letters = 'letter',
  ApplicationForms = 'banking'
}
